(() => {
  const endpoint = '/apps/kc-launches/campaigns';
  let scanTimer = null;

  const number = value => new Intl.NumberFormat().format(Number(value || 0));

  const daysLeft = value => {
    if (!value) return '';
    const end = new Date(value.length === 10 ? value + 'T23:59:59' : value);
    if (Number.isNaN(end.getTime())) return '';
    const days = Math.ceil((end.getTime() - Date.now()) / 86400000);
    if (days < 0) return '';
    if (days === 0) return 'Ends today';
    return days === 1 ? '1 day left' : days + ' days left';
  };

  const setText = (el, value) => {
    if (el && el.textContent !== value) el.textContent = value;
  };

  const renderCard = (el, campaign) => {
    const units = Number(campaign.units_sold || 0);
    const goal = Math.max(1, Number(campaign.goal_units || 1));
    const pct = Math.max(0, Math.min(100, Number(campaign.percent || (units / goal * 100))));
    const approved = Boolean(campaign.production_approved);

    el.classList.toggle('is-approved', approved);
    setText(el.querySelector('[data-kc-card-label]'), approved ? 'PRODUCTION APPROVED' : 'FUNDING');
    setText(el.querySelector('[data-kc-card-count]'), approved ? number(units) + ' preorders' : number(units) + ' / ' + number(goal));
    const fill = el.querySelector('[data-kc-card-fill]');
    if (fill) fill.style.width = (pct > 0 ? Math.max(2.5, pct) : 0) + '%';
    setText(el.querySelector('[data-kc-card-progress]'), approved ? 'Production confirmed' : Math.round(pct) + '% funded');

    const time = daysLeft(campaign.ends_at);
    const remaining = Number(campaign.remaining_units || 0);
    setText(
      el.querySelector('[data-kc-card-remaining]'),
      approved ? (time || 'Preorders open') : (time || (remaining > 0 ? number(remaining) + ' to goal' : 'Goal reached'))
    );

    el.hidden = false;
    el.dataset.kcCampaignState = 'active';
  };

  const hydrateCards = async () => {
    const cards = [...document.querySelectorAll('[data-kc-launch-card][data-product-id]')]
      .filter(el => !el.dataset.kcCampaignState);
    if (!cards.length) return;

    const ids = [...new Set(cards.map(el => el.dataset.productId).filter(id => /^\d+$/.test(id)))].slice(0, 50);
    if (!ids.length) return;

    cards.forEach(el => { el.dataset.kcCampaignState = 'loading'; });

    try {
      const response = await fetch(endpoint + '?product_ids=' + encodeURIComponent(ids.join(',')), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('KC Launches card request failed: ' + response.status);

      const payload = await response.json();
      const campaigns = payload.campaigns || {};

      cards.forEach(el => {
        const campaign = campaigns[el.dataset.productId];
        if (campaign) renderCard(el, campaign);
        else {
          el.hidden = true;
          el.dataset.kcCampaignState = 'none';
        }
      });
    } catch (error) {
      cards.forEach(el => { delete el.dataset.kcCampaignState; });
      console.warn('KC Launches product-card status unavailable', error);
    }
  };

  const polishProductGoal = root => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-kc-launches-goal]').forEach(block => {
      const unitsEl = block.querySelector('[data-kc-units]');
      const goalEl = block.querySelector('[data-kc-goal]');
      const label = block.querySelector('.kc-launches-goal__numbers > span');
      if (!unitsEl || !goalEl || !label) return;

      const units = Number((unitsEl.textContent || '').replace(/,/g, ''));
      const goal = Math.max(1, Number((goalEl.textContent || '').replace(/,/g, '')));
      if (!Number.isFinite(units) || !Number.isFinite(goal)) return;

      const desired = Math.round(Math.min(100, units / goal * 100)) + '% funded';
      setText(label, desired);
    });
  };

  const scan = root => {
    polishProductGoal(root || document);
    clearTimeout(scanTimer);
    scanTimer = setTimeout(hydrateCards, 120);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList' || !mutation.addedNodes.length) continue;

      let relevant = false;
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (
          node.matches?.('[data-kc-launch-card], [data-kc-launches-goal]') ||
          node.querySelector?.('[data-kc-launch-card], [data-kc-launches-goal]')
        ) {
          relevant = true;
          break;
        }
      }

      if (relevant) {
        scan(document);
        break;
      }
    }
  });

  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', e => scan(e.target));
})();